import type { PublicPlan, TaskEvent } from "./types";

export function publicPlanFromEvent(event: TaskEvent): PublicPlan | null {
  const value = event.payload?.plan;
  if (
    !value ||
    typeof value !== "object" ||
    !("plan_hash" in value) ||
    !("objective" in value) ||
    !("operations" in value) ||
    !Array.isArray(value.operations)
  ) {
    return null;
  }
  return value as unknown as PublicPlan;
}

export function isPlanSnapshotEvent(event: TaskEvent): boolean {
  return (
    event.event_type === "plan_ready" ||
    event.event_type === "working_plan_created" ||
    event.event_type === "working_plan_updated"
  );
}
